var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAdditionallyIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1768 11.8232C12.2744 11.9209 12.2744 12.0791 12.1768 12.1768C12.0791 12.2744 11.9209 12.2744 11.8232 12.1768C11.7256 12.0791 11.7256 11.9209 11.8232 11.8232C11.9209 11.7256 12.0791 11.7256 12.1768 11.8232",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1768 11.8232C16.2744 11.9209 16.2744 12.0791 16.1768 12.1768C16.0791 12.2744 15.9209 12.2744 15.8232 12.1768C15.7256 12.0791 15.7256 11.9209 15.8232 11.8232C15.9209 11.7256 16.0791 11.7256 16.1768 11.8232",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17678 11.8232C8.27441 11.9209 8.27441 12.0791 8.17678 12.1768C8.07915 12.2744 7.92085 12.2744 7.82322 12.1768C7.72559 12.0791 7.72559 11.9209 7.82322 11.8232C7.92085 11.7256 8.07915 11.7256 8.17678 11.8232",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3V3C16.971 3 21 7.029 21 12V12C21 16.971 16.971 21 12 21Z",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdditionallyIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AdditionallyIcon.36f5542a.svg";
export { ForwardRef as ReactComponent };